import { Box, Button } from "@chakra-ui/react";
import {
  colors,
  HStack,
  LargeButton,
  LARGEL_BUTTON_TYPE,
  Spinner,
  useResponsive,
} from "goi_common";

export default function RequestUniqueFixedButton({
  handleSubmit,
  handlePageLocation,
  loading,
  disabled,
  isTest,
  isFixed = true,
}: {
  handleSubmit: () => void;
  handlePageLocation: () => void;
  loading: boolean;
  disabled: boolean;
  isTest?: boolean;
  isFixed?: boolean;
}) {
  const { isBiggerThanMd } = useResponsive();
  return isTest ? (
    <Button
      onClick={handleSubmit}
      isDisabled={disabled || loading}
      background={colors.orange650}
      color="white"
      _hover={{ background: colors.orange500 }}
      _disabled={{
        background: colors.orange400,
      }}
      borderRadius="36px"
      width="100%"
    >
      다음
    </Button>
  ) : (
    <HStack
      position="fixed"
      style={{
        bottom: 0,
        marginTop: "110px",
      }}
      width={isBiggerThanMd ? "480px" : "100%"}
      maxWidth={isBiggerThanMd ? "var(--global-max-width)" : "480px"}
    >
      <LargeButton
        buttonType={LARGEL_BUTTON_TYPE.ORANGE}
        borderRadius={"0 0 0 10px"}
        height={60}
        onClick={handlePageLocation}
      >
        <Box display="flex">장례 준비 가이드 알아보기</Box>
      </LargeButton>
      <LargeButton
        buttonType={disabled ? LARGEL_BUTTON_TYPE.DISABLED : LARGEL_BUTTON_TYPE.PRIMARY}
        disabled={disabled}
        borderRadius={"0 0 10px 0"}
        height={60}
        onClick={handleSubmit}
      >
        <Box display="flex">{loading ? <Spinner /> : "비용 알아보기"}</Box>
      </LargeButton>
    </HStack>
  );
}
